/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Import all images
// <%= image_pack_tag 'media/images/my-image.png' %>
// <%= path_pack_tag 'media/images/my-image.png' %>
require.context('../images', true);

import $ from 'jquery';
import turbolinks from 'turbolinks';
import Rails from '@rails/ujs';

import 'popper.js';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/button';

import '../vendor/rails_sortable';

global.$ = jQuery;
global.jQuery = jQuery;

const handleBookingModal = (e) => {
  var but = $(e.relatedTarget); // Button that triggered the modal
  var ses = but.data('session'); // Extract info from data-* attributes
  var sat = but.data('starts-at');
  var eat = but.data('ends-at');
  var opt = but.data('tutor-shift-options');

  $('#booking-modal').find('.session').text(ses);
  $('#workshops_booking_starts_at').val(sat);
  $('#workshops_booking_ends_at').val(eat);
  $('#workshops_booking_tutor_shift_id').empty().append(opt);
};

const handleChangeNewTerm = (e) => {
  const $el = $('#term_name');

  let search = '';
  let replace = '';

  switch (e.target.id) {
    case 'term_academic_year':
      search = /(\d{4})$/;
      replace = e.target.value;
      break;

    case 'term_number':
      search = /Term (\d{1})?/;
      replace = `Term ${e.target.value}`;
      break;

    case 'term_is_holiday':
      search = e.target.checked ? /(\d{4})$/ : 'Holiday ';
      replace = replace = e.target.checked ? 'Holiday $1' : '';
      break;
  }

  $el.attr('value', $el.attr('value').replace(search, replace));
};

const handleChangeMatrixClassTerm = (e) => {
  e.preventDefault();
  turbolinks.visit(`${window.location.pathname}?term_id=${e.target.value}`);
};

const handleClickToggleUi = (e) => {
  e.preventDefault();
  const reference = $(e.currentTarget).attr('reference');
  $(reference).toggle();
};

const handleEnrolmentRollover = (e) => {
  const $el = $(e.target);
  const $radios = $el.find('.radio_buttons');
  const $reasons = $el.find('.reasons_for_discontinuing');
  const $matrixClassId = $el.find('.matrix_class_id');

  $radios.on('change', (e) => {
    switch (e.target.value) {
      case 'rollover':
        $reasons.hide();
        $matrixClassId.hide();
        break;
      case 'change_classes':
        $reasons.hide();
        $matrixClassId.show();
        break;
      case 'discontinue':
        $reasons.show();
        $matrixClassId.hide();
        break;
    }
  });
};

const handleMenuCollapse = ($el, breakpoint = 768) => {
  const $menu = $('#main-menu');

  if ($el.width() <= breakpoint) {
    $menu.addClass('collapse');
  } else {
    $menu.removeClass('collapse');
  }
};

const handleSelectQuery = (e) => {
  turbolinks.visit(
    `${window.location.pathname}?${e.target.dataset.selectQuery}=${
      e.target.value
    }`
  );
};

$(document).on('turbolinks:load', () => {
  $(window).on('resize', (e) => handleMenuCollapse($(e.target), 768));
  setTimeout(() => $(window).trigger('resize'), 500);

  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover();
  $('[role=toggleUi]').on('click', handleClickToggleUi);
  $('.modal-enrolment-rollover').on('shown.bs.modal', handleEnrolmentRollover);
  $('[data-select-query]').on('change', handleSelectQuery);
  $('form#new_term').on('change', handleChangeNewTerm);
  $('form#new_matrix_class select#matrix_class_term_id').on(
    'change',
    handleChangeMatrixClassTerm
  );
  $('#booking-modal').on('show.bs.modal', handleBookingModal);
  $('.sortable').railsSortable();
});

Rails.start();
turbolinks.start();
